<script setup>
import { ref, computed } from 'vue';
import Icon from 'next/icon/Icon.vue';
import Button from 'next/button/Button.vue';
import { useSnakeCase } from 'dashboard/composables/useTransformKeys';
import { useMessageContext } from '../provider.js';
import { useEditorImage } from 'dashboard/composables/useEditorImage';

import GalleryView from 'dashboard/components/widgets/conversation/components/GalleryView.vue';

const props = defineProps({
  attachment: {
    type: Object,
    required: true,
  },
});
const hasError = ref(false);
const showGallery = ref(false);

const attachmentFile = computed(() => props.attachment);
const { handlerEditImage } = useEditorImage(attachmentFile);

const { filteredCurrentChatAttachments } = useMessageContext();

const handleError = () => {
  hasError.value = true;
};
</script>

<template>
  <div
    class="size-[72px] overflow-hidden contain-content rounded-xl cursor-pointer relative group"
    @click="showGallery = true"
  >
    <div
      v-if="hasError"
      class="flex flex-col items-center justify-center gap-1 text-xs text-center rounded-lg size-full bg-n-alpha-1 text-n-slate-11"
    >
      <Icon icon="i-lucide-circle-off" class="text-n-slate-11" />
      {{ $t('COMPONENTS.MEDIA.LOADING_FAILED') }}
    </div>
    <template v-else>
      <img
        class="object-cover w-full h-full skip-context-menu"
        :src="attachment.dataUrl"
        @error="handleError"
      />
      <div class="absolute right-2 bottom-2 hidden group-hover:flex gap-2">
        <Button
          xs
          solid
          slate
          icon="i-lucide-brush"
          class="opacity-60"
          @click.stop.prevent="handlerEditImage"
        />
      </div>
    </template>
  </div>
  <GalleryView
    v-if="showGallery"
    v-model:show="showGallery"
    :attachment="useSnakeCase(attachment)"
    :all-attachments="filteredCurrentChatAttachments"
    @error="handleError"
    @close="() => (showGallery = false)"
  />
</template>
